var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 750",
    style: {
      enableBackground: "new 0 0 2500 750"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1941182027472"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M733.2,0H16.7C12.2,0,8,1.8,4.9,4.9C1.8,8,0,12.3,0,16.7v716.6c0,4.4,1.8,8.7,4.9,11.8c3.1,3.1,7.4,4.9,11.8,4.9h716.6    c4.4,0,8.7-1.8,11.8-4.9c3.1-3.1,4.9-7.4,4.9-11.8V16.7c0-4.4-1.8-8.7-4.9-11.8C741.9,1.8,737.7,0,733.2,0z M499.9,483.3    c0,4.4-1.8,8.7-4.9,11.8c-3.1,3.1-7.4,4.9-11.8,4.9H266.6c-4.4,0-8.7-1.8-11.8-4.9c-3.1-3.1-4.9-7.4-4.9-11.8V266.7    c0-4.4,1.8-8.7,4.9-11.8c3.1-3.1,7.4-4.9,11.8-4.9h216.6c4.4,0,8.7,1.8,11.8,4.9c3.1,3.1,4.9,7.4,4.9,11.8V483.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2233.5,250h-216.6c-9.2,0-16.7,7.5-16.7,16.7v216.6c0,9.2,7.5,16.7,16.7,16.7h216.6c9.2,0,16.7-7.5,16.7-16.7V266.7    C2250.1,257.5,2242.7,250,2233.5,250L2233.5,250z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1983.4,0.1h-216.6c-9.2,0-16.7,7.5-16.7,16.7v216.6c0,9.2,7.5,16.7,16.7,16.7h216.6c9.2,0,16.7-7.5,16.7-16.7V16.7    C2000.1,7.5,1992.6,0.1,1983.4,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2483.3,0.1h-216.6c-9.2,0-16.7,7.5-16.7,16.7v216.6c0,9.2,7.5,16.7,16.7,16.7h216.6c9.2,0,16.7-7.5,16.7-16.7V16.7    C2500,7.5,2492.5,0.1,2483.3,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1983.4,500h-216.6c-9.2,0-16.7,7.5-16.7,16.7v216.6c0,9.2,7.5,16.7,16.7,16.7h216.6c9.2,0,16.7-7.5,16.7-16.7V516.7    C2000.1,507.4,1992.6,500,1983.4,500z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2483.3,500h-216.6c-9.2,0-16.7,7.5-16.7,16.7v216.6c0,9.2,7.5,16.7,16.7,16.7h216.6c9.2,0,16.7-7.5,16.7-16.7V516.7    C2500,507.4,2492.5,500,2483.3,500z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1608.1,0.1h-216.6c-9.2,0-16.7,7.5-16.7,16.7v216.6c0,9.2,7.5,16.7,16.7,16.7h216.6c9.2,0,16.7-7.5,16.7-16.7V16.7    C1624.8,7.5,1617.3,0.1,1608.1,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1608.1,500h-216.6c-9.2,0-16.7,7.5-16.7,16.7v216.6c0,9.2,7.5,16.7,16.7,16.7h216.6c9.2,0,16.7-7.5,16.7-16.7V516.7    C1624.8,507.4,1617.3,500,1608.1,500z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374.8,266.5c0-4.4-1.8-8.7-4.9-11.8c-3.1-3.1-7.4-4.9-11.8-4.9h-233.3V16.7c0-4.4-1.8-8.7-4.9-11.8    c-3.1-3.1-7.4-4.9-11.8-4.9H891.6c-4.4,0-8.7,1.8-11.8,4.9s-4.9,7.4-4.9,11.8v716.2c0,4.4,1.8,8.7,4.9,11.8    c3.1,3.1,7.4,4.9,11.8,4.9h216.6c4.4,0,8.7-1.8,11.8-4.9c3.1-3.1,4.9-7.4,4.9-11.8V499.8h233.3c4.4,0,8.7-1.8,11.8-4.9    c3.1-3.1,4.9-7.4,4.9-11.8L1374.8,266.5L1374.8,266.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkx);
export default __webpack_public_path__ + "static/media/okx.90a3c6b3eee469a8d13e04f15c1f8d8d.svg";
export { ForwardRef as ReactComponent };